<template>
    <el-checkbox-group v-model="values" @change="$emit('input', values)" style="width: calc(100% - 50px);">
        <el-checkbox v-for="(citem, cidx) in formData.options" :key="cidx" :label="citem.label">
            {{ citem.label }}
        </el-checkbox>
    </el-checkbox-group>
</template>
<script>
export default {
    props: {
        formData: {
            type: Object
        },
        value: {
            type: [Array, String, Number],
            default() {
                return [];
            }
        }
    },
    watch: {
        value: {
            handler(val) {
                let arr = JSON.parse(JSON.stringify(val))
                if (arr && typeof (arr) == 'object') {
                    this.values = arr;
                } else if (arr) {
                    this.values = arr.split(',');
                } else {
                    this.values = [];
                }
            },
            immediate: true
        },
    },
    data() {
        return {
            values: [],
        }
    },
    methods: {
        getWidth() {
            if (this.formData.col == 24) return true;
            return false;
        }
    }
}
</script>
<style lang="scss" scoped></style>